export class SubCompanyChannelsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSubCompanyChannels({ subCompanyId, config = {} }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/channels`, config);
  }

  async addSubCompanyChannel({ subCompanyId, channelId }) {
    return this.#http.post(`/api/sub-companies/${subCompanyId}/channels`, { channelId });
  }

  async removeSubCompanyChannel({ subCompanyId, channelId }) {
    return this.#http.delete(`/api/sub-companies/${subCompanyId}/channels/${channelId}`);
  }
}
